import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

import logo from "../../assets/images/Logo.jpeg";

function Navbar() {
  return (
    <div className="main-navbar">

      <div className="navbar-container">

        <Link to="/" className="navbar-brand">

          <img
            src={logo}
            alt="ABNB Seva Samiti & Vidya Charitable Trust"
            className="navbar-logo"
          />

          <div className="navbar-brand-text">

            <h1>
              ABNB SEVA SAMITI
            </h1>

            <h2>
              &amp; VIDYA CHARITABLE TRUST
            </h2>

            <p>
              Serve The Community. Secure The Future.
            </p>

          </div>

        </Link>

        <nav className="navbar-menu">

          <Link to="/">HOME</Link>

          <Link to="/about">ABOUT US</Link>

          <Link to="/membership">MEMBERSHIP</Link>


  

          <Link to="/contact">CONTACT</Link>

          

        </nav>

      </div>

    </div>
  );
}

export default Navbar;